import { fomatTime } from "@/components/common/utils/time";
import { fillNulls } from "@/components/common/utils/util";

export function formatMonitoringPositionData(data) {
	let data_arr = []

	let adPosition = []
	let position = []
	let realData = []
	if (data.length === 1) {
		// let time = new Date(data[0].createTime)
		// let utcTime = Date.UTC(time.getFullYear(), time.getMonth(), time.getDate(), time.getHours(), time.getMinutes())

		// position.push([utcTime, data[0].absolutePosition])
		// adPosition.push([utcTime, data[0].adAbsolutePosition])
		// for (let i = 1; i <= 6; i++) {
		// 	position.push([utcTime, null])
		// 	adPosition.push([utcTime, null])
		// }
		let time = fomatTime(new Date(data[0].createTime),'YYYY-MM-DD HH:mm:ss')
		position.push({ 
				y: data[0].absolutePosition,
				name: time
			})
		adPosition.push({
				y: data[0].adAbsolutePosition,
				name: time
			})
		realData.push(data[0])
		// for (let i = 1; i <= 6; i++) {
		// 	let obj = { y: null,name: time }
		// 	position.push({...obj})
		// 	adPosition.push({...obj})
		// 	realData.push({ ...obj})
		// }
	} else {
		data.forEach(i => {
			let time = fomatTime(new Date(i.createTime),'YYYY-MM-DD HH:mm:ss')
			// if(i.absolutePosition){
			position.push({y : i.absolutePosition  , name : time})
			// }
			// if(i.adAbsolutePosition){
			adPosition.push({y : i.adAbsolutePosition , name : time})
			realData.push(i)
			// adPosition.push([utcTime, i.adAbsolutePosition ? i.adAbsolutePosition : null])
			// }
		})
	}
	data_arr.push({
		name: '广告排名',
		zones: buildZones(adPosition,'#ff0000'),
		data: adPosition,
		zoneAxis: 'x',
		connectNulls: true
	})
	let zones = buildZones(position,'#00AAFFFF')
	let arr = JSON.parse(JSON.stringify(position))
	if (arr.length > 0){
		let last = arr.length > 0 ? arr.length - 1 : 0
		let ys = fillNulls(arr.map(i => i.y))
		arr[last].y = ys[last]
		zones =  buildZones(arr,'#00AAFFFF')
		position.map((item,index) => {
			if (!item.y){
				item.y = ys[index]
			}
		})
	}
	data_arr.push({
		connectNulls : true,
		name: '自然排名',
		data: position,
		zones: zones,
		zoneAxis: 'x',
	})
	
	let reOption = getOption(data_arr,realData)
	return reOption;
}

function buildZones(data,c) {
	var zones = [],
		i = -1,
		len = data.length,
		current, previous, dashStyle, value,color;

	while (data[++i] === null);
	zones.push({
		value: i
	});

	while (++i < len) {
		previous = data[i - 1].y;
		current = data[i].y;
		dashStyle = '';

		if (previous && !current) {
			dashStyle = 'solid';
			value = i - 0.9;
			color = c
		} else if (!previous && current) {
			dashStyle = 'shortDash';
			value = i;
			color = '#d4d4d4'
		}
		if (dashStyle) {
			let ob = {
				dashStyle: dashStyle,
				value: value,
				color : color,
			}
			zones.push(ob);
		}
	}

	return zones;
}

function getOption(data_arr,realData) {
	return {
		chart: {
			// zoomType: 'xy',
			type: 'spline',
		},
		subtitle: {
			text: document.ontouchstart === undefined ?
				'鼠标拖动可以进行缩放' : '手势操作进行缩放'
		},
		title: {
			text: '关键字排名趋势'
		},
		xAxis: {
			type: 'datetime',
			minTickInterval : 4,
			labels: {
				formatter: function() {
					// 这里的 `this.value` 表示当前标签的值
					return fomatTime(realData[this.value].createTime);
				}
			}
		},
		colors: ['rgb(255, 39, 68)', 'rgb(0, 170, 255)'],
		yAxis: {
			reversed: true,
			title: {
				text: ''
			},
		},
		tooltip: {
			formatter: function() {
				let obj = realData[this.x]
				return  '<div style="font-size: 15px">' +
					'<div style="font-size: 18px">' + fomatTime(obj.createTime,'YYYY-MM-DD HH:mm') + '</div>' +
					'<div style="margin-top: 5px"><span>搜索排名：</span><span class="emphasis-hint">' + (obj.absolutePosition || '--') + '</span></div>' +
					'<div><span>广告排名：</span><span  class="emphasis-hint">' + (obj.adAbsolutePosition|| '--') + '</span></div>' +
					'</div>'
			},
			useHTML : true,
			shared: true,
		},
		plotOptions: {
			spline: {
				states: {
					hover: {
						lineWidth: 6,
						radiusPlus : 3
					}
				},
				lineWidth: 5,
				marker: {
					// enabled: false
					radius: 2.6
				},

			},
		},
		series: data_arr,
	}
}
